import { useTranslation } from 'react-i18next'

import { Card, CardTitle, Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TransactionDetailCardSkeleton = () => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>
        {t('Transacción')}
        <Skeleton variant="circular" width={24} height={24} />
      </CardTitle>
      <Styles.MainContainer>
        <Styles.InfoContainer>
          <Skeleton variant="rounded" width="100%" height={40} />
          <Styles.TransactionTypeContainer>
            <Skeleton variant="rounded" width={90} height={24} />
            <Skeleton variant="rounded" width={110} height={24} />
          </Styles.TransactionTypeContainer>
          <Styles.DatesContainer>
            <Skeleton variant="rounded" width={100} height={16} />
            <Skeleton variant="rounded" width={120} height={14} />
          </Styles.DatesContainer>
        </Styles.InfoContainer>

        <Divider />

        <Styles.SummaryContainer>
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="50%" height={16} />
          <Skeleton variant="rounded" width="55%" height={16} />
        </Styles.SummaryContainer>

        <Skeleton variant="rounded" width="100%" height={48} />
      </Styles.MainContainer>
    </Card>
  )
}

export default TransactionDetailCardSkeleton
